import "goi_common/src/styles/globals.css";
import {
  AppBar,
  Button,
  Container,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Box,
} from "@mui/material";
import { AllRegionLayout, GOI_WEB_URL, GoiHeaderBanner } from "goi_common";

import { parlorRegion } from "../constants/parlorRegion";
import { colors, useResponsive } from "goi_common";
import Footer from "goi_common/src/components/Footer";

const regionLayout = parlorRegion.layout;

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isBiggerThanMd } = useResponsive();
  return (
    <>
      <AppBar position="fixed" elevation={0} style={regionLayout.layoutStyle}>
        <Toolbar
          variant="dense"
          style={{
            width: "100%",
            maxWidth: "1280px",
            margin: "auto",
            position: "relative",
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            href="/"
            sx={{
              background: "white",
            }}
          >
            <img src="/favicon.svg" width="30px" />
          </IconButton>
          <Stack
            direction="row"
            color="black"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            position="relative"
            zIndex={2}
          >
            <Stack direction="row">
              <Typography
                fontFamily="GmarketSans"
                fontWeight={700}
                fontSize="14px"
                variant="h6"
                color={regionLayout.layoutStyle.color}
              >
                {regionLayout.headTitle}
                <span className="orange650 head_24_b">.</span>
              </Typography>
            </Stack>
            {isBiggerThanMd && (
              <a href={GOI_WEB_URL + "/match/request/?utm_source=dogsound"}>
                <Button variant="outlined" sx={regionLayout.ctaButtonStyle}>
                  장례 예상 비용 알아보기
                </Button>
              </a>
            )}
          </Stack>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="sm"
        style={{ padding: "60px 0 0", overflow: "visible", minHeight: "100vh" }}
      >
        <Box
          sx={{
            position: "fixed",
            top: "60px",
            width: "100%",
            maxWidth: "600px",
            zIndex: (theme) => theme.zIndex.appBar - 1,
          }}
        >
          <GoiHeaderBanner />
        </Box>
        <Box sx={{ paddingTop: "36px" }}>
          <AllRegionLayout eventPath="ch" accentColor={parlorRegion.regionColor.c400}>{children}</AllRegionLayout>
        </Box>
      </Container>
      <Footer />
    </>
  );
}
